<template>
  <the-header></the-header>
  <main>
    <job-listings></job-listings>
  </main>
  <footer>
    <div class="attribution mb-3">
      Challenge by
      <a href="https://www.frontendmentor.io?ref=challenge" target="_blank"
        >Frontend Mentor</a
      >. Coded by
      <a
        href="https://www.frontendmentor.io/profile/cliffordjfedev"
        target="_blank"
        >Clifford J.</a
      >
    </div>
  </footer>
</template>

<script>
import JobListings from "./components/JobListings.vue";
import TheHeader from "./components/layouts/TheHeader.vue";

export default {
  name: "App",
  components: { JobListings, TheHeader },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=League+Spartan:wght@400;500;700&display=swap");

#app {
  font-family: "League Spartan", sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body {
  background-color: hsl(180, 52%, 96%);
}
.max-min-width {
  min-width: 21.875rem;
  // min-width: 23.4375rem !important;
  max-width: 90rem !important;
  margin: auto;
}

.attribution {
  font-size: 11px;
  text-align: center;
}
.attribution a {
  color: hsl(180, 14%, 20%);
  transition: all linear 400ms;
}

.attribution a:hover {
  color: hsl(180, 29%, 50%);
}
</style>
